// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@ces/App/Store/Reducers";
import { getSystemColor } from "@ces/XDL/Utilities";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import * as React from "react";
import { shallowEqual } from "react-redux";
import { Transition } from "react-transition-group";
import { TransitionStatus } from "react-transition-group/Transition";
import styled, { ThemeProps } from "styled-components";

export const StyledOverlayComponent = styled.div<{ transitionState: TransitionStatus } & ThemeProps<BaseTheme>>`
    position: fixed;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: ${getSystemColor("text.main", 0.33)};
    z-index: ${({ theme }: any) => theme.zIndex.styledOverlay};
    transition: opacity ease-in-out 250ms;
    ${({ transitionState }) => {
        switch (transitionState) {
            case "entering":
                return "opacity: 0;";
            case "entered":
                return "opacity: 1;";
            case "exiting":
            case "exited":
                return "opacity: 0;";
            default:
                return "";
        }
    }}
`;

const StyledOverlay = () => {
    const { isTabletScreen, registerMenu } = useAppSelector(
        state => ({
            isTabletScreen: (state as CustomAppState).xCommon.isTabletScreen,
            registerMenu: (state as CustomAppState).xHeader.registerMenu,
        }),
        shallowEqual,
    );

    return (
        <Transition
            mountOnEnter
            unmountOnExit
            in={registerMenu && registerMenu.length > 0}
            timeout={{ enter: 75, exit: 250 }}
        >
            {state => (
                <StyledOverlayComponent
                    className={registerMenu && isTabletScreen ? "header-overlay" : ""}
                    transitionState={state}
                />
            )}
        </Transition>
    );
};

export default StyledOverlay;
